define('controllers/mysetting/HandlerUserInfoController',['app'], function (app) {
    app.controller('HandlerUserInfoController', ['$state', '$scope', 'UserInfo', 'modUserInfoService', '$rootScope', function ($state, $scope, UserInfo, modUserInfoService, $rootScope) {
        $scope.userInfo = UserInfo.get();
        $scope.userType = UserInfo.get().userType;
        $rootScope.toSettingUserInfo();
    }])
});
